import { useFormContext } from 'react-hook-form';
import { LwFormInput } from 'redesign';
import { getRequiredMessage } from './shared';
import { ContactPhoneWithPrefixFormContext, Props } from './contact-phone.types';

export const ContactPhoneWithPrefixInput = (props: Props) => {
  const { control } = useFormContext<ContactPhoneWithPrefixFormContext>();
  const formName = 'contactPhoneWithPrefix';
  const label = 'Telefoon contactpersoon';
  const requiredMessage = getRequiredMessage(label);

  return (
    <LwFormInput
      name={formName}
      control={control}
      label={label}
      disabled={props.disabled}
      rules={props.required ? { required: requiredMessage } : undefined}
    />
  );
};
